module.exports = __webpack_public_path__ + "media/tr_tr_s5_Reyhan.a2a6d9bf.oga";